module.exports = __webpack_public_path__ + "gym-9ba0c4731245aad394386d15a0f5ecac.svg";